import { render, staticRenderFns } from "./TableCellItem.vue?vue&type=template&id=3a8fa1ed"
import script from "./TableCellItem.vue?vue&type=script&lang=js"
export * from "./TableCellItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports